/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 11:26 AM
 */

"use strict";

var _ = require('underscore');
var TransactionShipmentQuote = require('../../../ecomm/TransactionShipmentQuote');
var getFromCollection;

getFromCollection = function (collectionProperty, fn) {
    var args = Array.prototype.slice.call(arguments, 2);
    var collection = this.get(collectionProperty);
    if (collection) {
        return collection[fn].apply(collection, args);
    }
};

/**
 * Transaction mixin for accessing sub-documents
 * @type {{}}
 */
module.exports = {
    /******************************
        Payment Authorizations
    ******************************/
    /**
     * Get the active payment auth that is anchored to an offer. This includes fraudulent payment auths
     */
    getOfferPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveOfferPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote. This includes fraudulent payment auths
     */
    getShippingPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveShippingPaymentAuthorization'),
    /**
     * Get the current payment auth that is anchored to an offer and has not yet been processed
     */
    getCurrentCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentCheckoutPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote and has not yet been processed
     */
    getCurrentBalanceDuePaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentBalanceDuePaymentAuthorization'),
    /**
     * Get a denied payment auth that is anchored to an offer
     */
    getDeniedCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getDeniedCheckoutPaymentAuthorization'),
    /**
     * Get a statged payment auth ready to send to braintree
     */
    getStagedPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getStagedPaymentAuthorization'),
    getCheckoutPaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getCheckoutPaymentAuthorizationForProcessing'),
    getBalanceDuePaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getBalanceDuePaymentAuthorizationForProcessing'),

    /******************************
        Offers
     ******************************/
    getMostRecentOffer: _.partial(getFromCollection, 'offers', 'getMostRecent'),
    getFirstOffer: _.partial(getFromCollection, 'offers', 'getFirst'),
    getMostRecentBuyerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentBuyerOffer'),
    getMostRecentDealerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentDealerOffer'),

    /******************************
        Shipment Quotes
     ******************************/
    getPaymentRequiredQuote: function () {
        var quotes = this.get('shipmentQuotes');
        return quotes && quotes.findWhere({status: 'PAYMENT_REQUIRED'});
    },
    getCurrentShippingQuote : function () {
        var acceptedQuote = this.getAcceptedQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();
        var dealerQuote = this.getDealerShipmentQuote();
        var activeQuote;

        if (acceptedQuote) {
            activeQuote = acceptedQuote;
        } else if (dealerQuote) {
            activeQuote = dealerQuote;
        } else if (dibsQuote
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_NEW
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_SUBMITTED
        ) {
            activeQuote = dibsQuote;
        }
        return activeQuote;
    },
    getCurrentOrSubmittedShipmentQuote: function () {
        var currentShippingQuote = this.getCurrentShippingQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();

        if (currentShippingQuote) {
            return currentShippingQuote;
        } else if (dibsQuote && dibsQuote.isQuoteSubmitted()) {
            return dibsQuote;
        }

        return null;
    },
    getDealerAcceptedQuote : function () {
        return this.get('shipmentQuotes').find(function (quote) {
            return _.contains(['PAYMENT_REQUIRED', 'BUYER_ACCEPTED'], quote.get('status'));
        });
    },
    getAcceptedQuote : function () {
        var acceptedQuote = this.get('shipment.acceptedQuote');
        if (!acceptedQuote || acceptedQuote.isLocalPickup()) {
            return undefined;
        }
        return acceptedQuote;
    },
    /**
     * Gets the current active accounting shipment quote.
     * This is the shipment quote on a transaction that is
     * not 'DEALER_REJECTED'. At this point in time, there
     * should not be more than on of these on an order.
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getActiveAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuote'),
    /**
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getRejectedAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getRejectedAccountingQuote'),
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteSubTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteSubTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    get1stdibsShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'get1stdibsQuote'),
    getDealerShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getDealerQuote'),
    getBuyerShipmentQuote: function () {
        var quote = this.getCurrentShippingQuote();

        if (quote && quote.get("status") !== "SUBMITTED") {
            return quote;
        }
    },

    /******************************
        Invoices
     ******************************/
    getDealerInvoice: _.partial(getFromCollection, 'invoices', 'getDealerInvoice'),
    getShipperInvoice: _.partial(getFromCollection, 'invoices', 'getShipperInvoice'),
    getBuyerInvoice: _.partial(getFromCollection, 'invoices', 'getBuyerInvoice'),
    getBuyerInvoiceItems: function () {
        var buyerInvoice = this.getBuyerInvoice();
        return buyerInvoice && buyerInvoice.get('invoiceItems');
    },

    /******************************
        Disbursements
     ******************************/
    getShipperDisbursement: _.partial(getFromCollection, 'disbursements', 'getShipperDisbursement'),
    getDealerDisbursement: _.partial(getFromCollection, 'disbursements', 'getDealerDisbursement'),

    /******************************
        Promotions
     ******************************/
    getActivePromo: _.partial(getFromCollection, 'promotions', 'getActivePromo'),
    getInvalidPromo: _.partial(getFromCollection, 'promotions', 'getInvalidPromo'),

    /******************************
        Notes
     ******************************/
    getReadyForPickupNote: function () {
        var shipment = this.get('shipment');
        if (shipment && !this.isDealerAuthoredShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        }
    },
    getShippedNote: function () {
        var shipment = this.get('shipment');
        if (shipment && this.isDealerShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        } else if (shipment && this.is1stdibsShipping()) {
            return shipment.get('notes').getByCreatorRole('INTERNAL');
        }
    },
    getBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getBuyerSellerNotes'),
    getUnanchoredBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getUnanchoredBuyerSellerNotes'),

    /******************************
        Item
     ******************************/
    getVertical: function () {
        return this.get('item.vertical');
    },

    /******************************
     Adjustments
     ******************************/
    getListingCreditAdjustment: function () {
        var invoice = this.getDealerInvoice();
        if (invoice) {
            return invoice.getListingCreditAdjustment();
        }
    },

    /******************************
        DisplayMetadata
     ******************************/
    getSlaStartDate: function () {
        return this.get('displayMetadata.sla.startDate');
    },

    /******************************
     Addresses
     ******************************/
    getShippingAddresses: function () {
        var addressBook = this.get('buyer.addressBook');
        var shippingAddresses = addressBook.getShippingAddresses() || [];
        return shippingAddresses;
    },
    getFirstShippingAddress: function () {
        var addresses = this.getShippingAddresses();
        return addresses && addresses[0];
    },

    /******************************
     Reviews
     ******************************/
    getFraudReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getFraudReview();
    },

    getPaymentReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getPaymentReview();
    },

    /******************************
     Actions
     ******************************/
    getActionStartDate: _.partial(getFromCollection, 'actions', 'getActionStartDate')

};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/ecomm/Transaction/transactionDocumentAccessMixin.js
// module id = 195
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54